// import { Component, OnInit } from '@angular/core';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ClientsService } from '@app/shared/services/clients.service';
import { OrderService } from '@app/shared/services/order.service';
import { JssService } from '@app/shared/services/jss.service';
import { Router } from '@angular/router';
import { MatMixService } from '@app/shared/services/mat-mix.service'; 

@Component({
  selector: 'app-production-form',
  templateUrl: './production-form.component.html',
  styleUrls: ['./production-form.component.css']
})
export class ProductionFormComponent implements OnInit {
  addPrintingDetailForm: FormGroup;
  clientList: any[] = [];
  jobList: any[] = [];
  orderList: any[] = [];

  materialMixEntries: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 15;
  ClientName: string = ''; // Property to hold the selected client's name
  JobName: string = ''; // Property to hold the selected job's name
  selectedMaterials: string[] = [];

  formSubmitted: boolean = false;
  showNextButton: boolean = false; // Initially hide the next button

  constructor(
    private fb: FormBuilder,
    private orderService: OrderService,
    private clientsService: ClientsService,
    private jss: JssService,
    private cdr: ChangeDetectorRef,
    private router: Router, 
    private matMixService: MatMixService,
  ) { 
    this.addPrintingDetailForm = this.fb.group({
      clientName: [''],
      jobName: [''],
      refNo: [''],
      poNo: [''],
      // curecipeId: [''],
      // customerRecipe: [''],
      orderKgs: [''],
      shift:[''],
     machine :[''],
      operator :[''],
     operatingTime :[''],
     timeFrom :[''],
     timeTo :[''],
     mcSpeed :[''],
     inkGsm :[''],
      availableTime :[''],
      // ... other form controls
    });
  }

  ngOnInit(): void {
    // Fetch data from the services
    this.clientsService.getClientList().subscribe(
      (clients: any[]) => {
        this.clientList = clients;
      },
      (error) => {
        console.error('Error fetching clients:', error);
      }
    );

    this.orderService.getOrder().subscribe((orders: any[]) => {
      this.orderList = orders;
    });

    // Listen for changes on the 'clientName' form control
    this.addPrintingDetailForm.get('clientName').valueChanges.subscribe((selectedClient) => {
      // Update jobList based on the selected client
      this.jobList = this.orderList
        .filter(order => order.clientName.toLowerCase() === selectedClient.toLowerCase())
        .map(order => order.jobName);

      // Reset the jobName selection and clear other form controls when the client changes
      // this.addPrintingDetailForm.patchValue({
      //   jobName: null,
      //   refNo: null,
      //   poNo: null,
      //   // ... reset other form controls
      // });
    });

    // Listen for changes on the 'jobName' form control
    this.addPrintingDetailForm.get('jobName').valueChanges.subscribe((selectedJob) => {
      // Find the selected job from the order list
      const job = this.orderList.find(order => order.jobName === selectedJob);

      // Update form controls based on the selected job
      this.addPrintingDetailForm.patchValue({
        refNo: job ? job.refNo : null,
        poNo: job ? job.poNo : null,

        orderKgs: job ? job.orderKgs : null,
        // ... update other form controls
      });
    });





    // Fetch data from the services
    this.clientsService.getClientList().subscribe(
      (clients: any[]) => {
        this.clientList = clients;
        this.cdr.detectChanges(); // Manually trigger change detection

      },
      (error) => {
        console.error('Error fetching clients:', error);
      }
    );
  

    // for filtering those orders whose jss is created
    this.jss.getJssList().subscribe((orders: any[]) => {
      // Filter orders to include only reconfirmed ones
      this.orderList = orders.filter(order => order.status === 'CreateJss');
    });
  
    // Listen for changes on the 'clientName' form control
    this.addPrintingDetailForm.get('clientName').valueChanges.subscribe((selectedClient) => {
      // Update the ClientName property with the selected client's name
      this.ClientName = selectedClient;
      // Update jobList based on the selected client
      this.updateJobList(selectedClient);
    });
  
    // Listen for changes on the 'jobName' form control
    this.addPrintingDetailForm.get('jobName').valueChanges.subscribe((selectedJob) => {
      // Update the JobName property with the selected job's name
      this.JobName = selectedJob;
      console.log(this.JobName);
      // Fetch JSS data for the selected client and job
      // this.fetchJssData(selectedJob);
    });

  }




 




//to fetch ref no and po no on selection of client name
  onClientChange(selectedClient: string): void {
    const selectedOrder = this.orderList.find(order => order.clientName.toLowerCase() === selectedClient.toLowerCase());
    if (selectedOrder) {
      this.addPrintingDetailForm.patchValue({
        refNo: selectedOrder.refNo,
        poNo: selectedOrder.poNo,

        orderKgs: selectedOrder.orderKgs,
        // ... update other form controls if needed
      });
    } else {
      // Reset form controls if no matching order found
      this.addPrintingDetailForm.patchValue({
        refNo: null,
        poNo: null,

        orderKgs: null,
        // ... reset other form controls if needed
      });
    }
  }

  viewJob(): void {
    // Implement logic for viewing job details
    console.log('View Job Clicked');
  }

  viewRecipe(): void {
    // Implement logic for viewing recipe details
    console.log('View Recipe Clicked');
  }

  // addPrintingDetail(): void {
  //   const newMaterialMixEntry = {
  //     clientName: this.addPrintingDetailForm.value.clientName,
  //     jobName: this.addPrintingDetailForm.value.jobName,
  //     refNo: this.addPrintingDetailForm.value.refNo,
  //     poNo: this.addPrintingDetailForm.value.poNo,
  //     orderQuantity: this.addPrintingDetailForm.value.orderQuantity,
  //   };
  //   // Push the new entry to the array or send it to a service for further processing
  //   this.materialMixEntries.push(newMaterialMixEntry);
  // }

  addPrintingDetail(): void {
    // Create a new material mixing object with form values
    const newMaterialMixEntry = {
      clientName: this.addPrintingDetailForm.value.clientName,
      jobName: this.addPrintingDetailForm.value.jobName,
      matArray: [{
        materialMix: this.addPrintingDetailForm.value.process || this.addPrintingDetailForm.value.material,
        refNo: this.addPrintingDetailForm.value.refNo,
    poNo: this.addPrintingDetailForm.value.poNo,
   orderKgs: this.addPrintingDetailForm.value.orderKgs,

   clientName: this.addPrintingDetailForm.value.clientName,
      jobName: this.addPrintingDetailForm.value.jobName,

      shift: this.addPrintingDetailForm.value.shift,

      machine: this.addPrintingDetailForm.value.machine,
      operator: this.addPrintingDetailForm.value.operator,
      operatingTime: this.addPrintingDetailForm.value.operatingTime,
      timeFrom: this.addPrintingDetailForm.value.timeFrom,
      timeTo: this.addPrintingDetailForm.value.timeTo,
      mcSpeed: this.addPrintingDetailForm.value.mcSpeed,
      inkGsm: this.addPrintingDetailForm.value.inkGsm,
      availableTime: this.addPrintingDetailForm.value.availableTime,
        
      }]
    };
  
    console.log(newMaterialMixEntry);
  
    // Update the local array to include the new material mixing entry
    this.materialMixEntries.push(newMaterialMixEntry);
    
    console.log(this.materialMixEntries);
    this.removeSelectedProcessFromDropdown();



     // Once form is submitted successfully, set formSubmitted to true
     this.formSubmitted = true;
     // Show the next button after form submission
     this.showNextButton = true;
  }

  saveAndContinue(): void {
    if (this.materialMixEntries.length === 0 || !this.ClientName || !this.JobName) {
      console.error('No material mix entries to save or missing client name/job name.');
      return;
    }
  
    const orderId = this.getOrderId(this.ClientName, this.JobName);
  
    const matArray = this.materialMixEntries.map(entry => ({
      materialMix: entry.matArray[0].materialMix,
      refNo: entry.matArray[0].refNo,
      poNo: entry.matArray[0].poNo,
      orderKgs: entry.matArray[0].orderKgs,
      ClientName: entry.matArray[0].ClientName,
      jobName: entry.matArray[0].jobName,
      shift: entry.matArray[0].shift,

      machine: entry.matArray[0].value.machine,
      operator: entry.matArray[0].value.operator,
      operatingTime: entry.matArray[0].value.operatingTime,
      timeFrom: entry.matArray[0].value.timeFrom,
      timeTo: entry.matArray[0].value.timeTo,
      mcSpeed: entry.matArray[0].value.mcSpeed,
      inkGsm: entry.matArray[0].value.inkGsm,
      availableTime: entry.matArray[0].value.availableTime,

    }));
  
    const dataToSave = {
      orderId: orderId,
      clientName: this.ClientName,
      jobName: this.JobName,
      matArray: matArray
    };
  
    this.matMixService.createMatMix(dataToSave).subscribe(
      (response) => {
        console.log('Material mix entries saved successfully:', response);
        this.materialMixEntries = [];
        // Redirect to the desired route after saving
        this.router.navigate(['/matAllot'], { queryParams: { orderId: orderId } });
      },
      (error) => {
        console.error('Error saving material mix entries:', error);
      }
    );
  }
  
  

  removeSelectedProcessFromDropdown(): void {
    const selectedProcessIndex = this.selectedMaterials.indexOf(this.addPrintingDetailForm.value.process);
    if (selectedProcessIndex !== -1) {
      this.selectedMaterials.splice(selectedProcessIndex, 1);
    }
  }

  getOrderId(clientName: string, jobName: string): string {
    // Find the order in the orderList based on the clientName and jobName
    const order = this.orderList.find(order =>
      order.clientName.toLowerCase() === clientName.toLowerCase() &&
      order.jobName.toLowerCase() === jobName.toLowerCase()
    );
    // If the order is found, return its orderId, otherwise return an empty string
    return order ? order.orderId : '';
  }







  updateJobList(selectedClient: string): void {
    if (selectedClient) {
      // Update jobList based on the selected client
      this.jobList = this.orderList
        .filter(order => order.clientName.toLowerCase() === selectedClient.toLowerCase())
        .map(order => order.jobName);
    } else {
      this.jobList = [];
    }
  
    // Reset the jobName selection when the client changes
    // this.addPrintingDetailForm.patchValue({
    //   jobName: null,
    // });
  }







  get paginatedMaterialMixEntries(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.materialMixEntries.slice(startIndex, endIndex);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  calculateRangeStart(): number {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  calculateRangeEnd(): number {
    const endIndex = this.currentPage * this.itemsPerPage;
    return Math.min(endIndex, this.materialMixEntries.length);
  }

  getNumberRangeMatMix(pages: number): number[] {
    return Array(pages).fill(0).map((x, i) => i + 1);
  }
  ceilValue(value: number): number {
    return Math.ceil(value);
  }

   // Function to navigate to add-ink component
   navigateToAddInk() {
    this.router.navigate(['/addInk']); // Assuming 'add-ink' is the route path to your add-ink component
  }

  //calculation of wastegae ,matrequired 
  // calculateMatRequired(index: number) {
  //   const entry = this.paginatedMaterialMixEntries[index];
  //   // Implement your formula here
  //   const matRequired = entry.matArray[0].thickness * entry.matArray[0].orderper / 100; // Example formula
  //   // Update Mat_Required value
  //   entry.matArray[0].matRequired = matRequired;
  // }


}
